import { MdOutlineDashboardCustomize } from "react-icons/md";
export const supplierMenu = [
  {
    name: "داشبورد",
    path: "/dashboard/suppliers",
    icon: <MdOutlineDashboardCustomize size={18} />,
    type: "menu",
    child: ["/dashboard/suppliers"],
  },
  {
    name: "حسابداری",
    path: "/dashboard/suppliers/accounting",
    icon: <MdOutlineDashboardCustomize size={18} />,
    type: "menu",
    child: [
      "/dashboard/suppliers/accounting",
      "/dashboard/suppliers/accounting/unconfirmedOrders",
      "/dashboard/suppliers/accounting/awaitingDelivery",
    ],
  },
  {
    name: "چت آنلاین",
    path: "/dashboard/suppliers/OnlineChat",
    icon: <MdOutlineDashboardCustomize size={18} />,
    type: "menu",
    child: ["/dashboard/suppliers/OnlineChat"],
  },
  {
    name: "واحد محتوا",
    path: "/dashboard/suppliers/ContentUnit",
    icon: <MdOutlineDashboardCustomize size={18} />,
    type: "menu",
    child: [
      "/dashboard/suppliers/ContentUnit",
      "/dashboard/suppliers/ContentUnit/Products",
      "/dashboard/suppliers/ContentUnit/Products/addNewProduct",
      "/dashboard/suppliers/ContentUnit/Products/myProduct",
      "/dashboard/suppliers/ContentUnit/Products/submitedProduct",
      "/dashboard/suppliers/ContentUnit/Products/changeProductStatus",
      "/dashboard/suppliers/ContentUnit/Products/activeProduct",
      "/dashboard/suppliers/ContentUnit/Products/finishedProduct",
      "/dashboard/suppliers/ContentUnit/Products/rockedProduct",
      "/dashboard/suppliers/ContentUnit/productCategory",
      "/dashboard/suppliers/ContentUnit/productCategory/level1-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/level2-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/level2-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/level3-product-category",
      "/dashboard/suppliers/ContentUnit/productCategory/addBrand",
      "/dashboard/suppliers/ContentUnit/productCategory/addTextTemplateTable",
      "/dashboard/suppliers/ContentUnit/features",
      "/dashboard/suppliers/ContentUnit/features/level-one",
      "/dashboard/suppliers/ContentUnit/features/level-two",
    ],
  },
  {
    name: "تیکت",
    path: "/dashboard/ticket",
    icon: <MdOutlineDashboardCustomize size={18} />,
    type: "menu",
    child: [],
  },
];
